/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AlignmentOptions } from './AlignmentOptions';
import {
    AlignmentOptionsFromJSON,
    AlignmentOptionsFromJSONTyped,
    AlignmentOptionsToJSON,
} from './AlignmentOptions';
import type { SequenceAlign } from './SequenceAlign';
import {
    SequenceAlignFromJSON,
    SequenceAlignFromJSONTyped,
    SequenceAlignToJSON,
} from './SequenceAlign';

/**
 * 
 * @export
 * @interface SequencesAlignRequest
 */
export interface SequencesAlignRequest {
    /**
     * 
     * @type {AlignmentOptions}
     * @memberof SequencesAlignRequest
     */
    alignmentOptions: AlignmentOptions;
    /**
     * 
     * @type {Array<SequenceAlign>}
     * @memberof SequencesAlignRequest
     */
    sequences: Array<SequenceAlign>;
}

/**
 * Check if a given object implements the SequencesAlignRequest interface.
 */
export function instanceOfSequencesAlignRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "alignmentOptions" in value;
    isInstance = isInstance && "sequences" in value;

    return isInstance;
}

export function SequencesAlignRequestFromJSON(json: any): SequencesAlignRequest {
    return SequencesAlignRequestFromJSONTyped(json, false);
}

export function SequencesAlignRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequencesAlignRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alignmentOptions': AlignmentOptionsFromJSON(json['alignmentOptions']),
        'sequences': ((json['sequences'] as Array<any>).map(SequenceAlignFromJSON)),
    };
}

export function SequencesAlignRequestToJSON(value?: SequencesAlignRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alignmentOptions': AlignmentOptionsToJSON(value.alignmentOptions),
        'sequences': ((value.sequences as Array<any>).map(SequenceAlignToJSON)),
    };
}

